<template>
    <v-card id="ts-nft-create-form" elevation="0">
        <v-tour name="welcome" :steps="getTourSteps('welcome')" :callbacks="tour.callbacks">
            <ts-v-tour-template></ts-v-tour-template>
        </v-tour>
        <v-tour id="welcome-substeps" name="welcome.subSteps" :steps="getTourSteps('welcome.subSteps')" :callbacks="tour.subStepCallbacks">
            <ts-v-tour-template></ts-v-tour-template>
        </v-tour>
        <v-row>
            <v-col class="d-flex">
                <v-btn id="example-button" text x-small @click="() => $vuetify.breakpoint.mobile ? openExampleInNewTab() : $emit('example')">Want to see an example?</v-btn>
                <v-spacer></v-spacer>
                <v-btn text x-small @click="tourButtonHandler">Tour</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="mx-auto rounded-lg" :outlined="$vuetify.breakpoint.mobile">
                    <v-form ref="form" v-model="valid" class="ts-nft" :class="$vuetify.breakpoint.mobile ? 'mobile' : ''">
                        <v-list-item three-line :class="$vuetify.breakpoint.mobile ? 'px-0' : ''">
                            <v-list-item-content>
                                <div class="mb-4">
                                    <v-row>
                                        <div class="d-flex flex-wrap" id="tour-step-brand-name-size">
                                            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 3" :class="$vuetify.breakpoint.mobile ? 'pt-0 pr-1 pb-0' : ''">
                                                <span class="font-weight-light font-italic">
                                                    <v-text-field :dense="$vuetify.breakpoint.mobile" id="bra_brand" :rules="rules.brand" label="Bra Brand" outlined v-model="$storeBraBrand"></v-text-field>
                                                </span>
                                            </v-col>
                                            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 3" :class="$vuetify.breakpoint.mobile ? 'py-0 pl-1' : ''">
                                                <span class="font-weight-light font-italic">
                                                    <v-text-field :dense="$vuetify.breakpoint.mobile" id="bra_name" :rules="rules.name" label="Bra Name" outlined v-model="$storeBraName"></v-text-field>
                                                </span>
                                            </v-col>
                                            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 2" :class="$vuetify.breakpoint.mobile ? 'py-0 pr-1' : ''">
                                                <span class="font-weight-light font-italic">
                                                    <v-text-field :dense="$vuetify.breakpoint.mobile" id="bra_size" validate-on-blur :rules="rules.size" label="Bra Size" hint="band and cup (i.e. 32N)" outlined v-model="$storeBraSize"></v-text-field>
                                                </span>
                                            </v-col>
                                            <v-col :cols="$vuetify.breakpoint.mobile ? 6 : 3" id="tour-step-color" class="d-flex justify-space-end" :class="$vuetify.breakpoint.mobile ? 'py-0 pl-1' : ''">
                                                <v-sheet elevation="4" class="pointer" @click.self="swatchClickHandler" rounded :height="brasizeInputHeight" :width="brasizeInputHeight" :color="$storeBraColor">
                                                    <v-color-picker :swatches="braColors" label="Bra Color" v-model="$storeBraColor"
                                                                    :show-swatches="showSwatches" hide-canvas hide-inputs hide-sliders dot-size="40" @update:color="swatchInputHandler"></v-color-picker>
                                                </v-sheet>
                                                <v-input type="hidden" :rules="rules.color" :value="swatch" ref="bra_color" id="bra_color"></v-input>
                                            </v-col>
                                        </div>
                                    </v-row>
                                </div>
                                <v-list-item-title class="text-h5 font-weight-regular mb-1">
                                    {{ username.first }}
                                    <span class="font-weight-thin font-italic">({{ username.nickname }})</span>
                                    {{ username.last }}
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="aliases && aliases.length">Aka <span class="ml-2" v-html="aliases"></span></v-list-item-subtitle>
                            </v-list-item-content>
                            <div v-if="!$vuetify.breakpoint.mobile" class="cube py-4" v-click-outside="onClickOutsideBra">
                                <v-sheet @dblclick.native="onDoubleClick" v-click-outside="onClickOutsideBra" :style="cssVars(assetProps.bra.backgroundUrl)" id="bra-sheet" class="rounded-lg face" :class="activeFaceClass('bra')" elevation="2">
                                    <!-- @update:error not working because of https://github.com/vuetifyjs/vuetify/issues/12715 -->
                                    <v-input id="bra" ref="bra"
                                             :value="assets.bra ? assets.bra.url : undefined"
                                             :class="$refs.bra && $refs.bra.error ? 'mt-2' : ''"
                                             :rules="rules.asset && rules.asset.bra ? rules.asset.bra : []"
                                             @update:error="function() { changeActiveFaceClass('bra') }">
                                        <file-pond class="image" ref="filepond_bra" name="filepond_bra" :label-idle="formatLabel('bra')"
                                                   accepted-file-types="image/*"
                                                   v-on:init="handleFilePondInit"
                                                   v-bind:files="files.bra"
                                                   @addfile="(error, file) => addfileHandler(file, 'bra')"
                                                   @removefile="(error, file) => removefileHandler(file, 'bra')"
                                                   @processfile="(error, file) => processfileHandler(file, 'bra')"
                                                   @activatefile="(error, file) => activatefileHandler(file, assets[1])"
                                                   stylePanelLayout="integrated"
                                                   :value="assets['bra'].serverId"
                                                   :server="server"
                                                   :credits="null"></file-pond>
                                    </v-input>
                                </v-sheet>
                                <v-sheet @dblclick.native="onDoubleClick" :style="cssVars(assetProps.tag.backgroundUrl)" id="tag-sheet" class="rounded-lg face" :class="activeFaceClass('tag')" elevation="2">
                                    <!-- @update:error not working because of https://github.com/vuetifyjs/vuetify/issues/12715 -->
                                    <v-input id="bra_tag" ref="tag"
                                             :value="assets.tag ? assets.tag.url : undefined"
                                             :class="$refs.tag && $refs.tag.error ? 'mt-2' : ''"
                                             :rules="rules.asset && rules.asset.tag ? rules.asset.tag : []"
                                             @update:error="function() { changeActiveFaceClass('tag') }">
                                        <file-pond class="image" ref="filepond_tag" name="filepond_tag" :label-idle="formatLabel('bra tag')"
                                                   accepted-file-types="image/*"
                                                   v-on:init="handleFilePondInit"
                                                   v-bind:files="files.tag"
                                                   @addfile="(error, file) => addfileHandler(file, 'tag')"
                                                   @removefile="(error, file) => removefileHandler(file, 'tag')"
                                                   @processfile="(error, file) => processfileHandler(file, 'tag')"
                                                   @activatefile="(error, file) => activatefileHandler(file, assets[0])"
                                                   stylePanelLayout="integrated"
                                                   :value="assets['tag'].serverId"
                                                   :server="server"
                                                   :credits="null"></file-pond>
                                    </v-input>
                                </v-sheet>
                            </div>
                        </v-list-item>
                        <v-sheet v-if="$vuetify.breakpoint.mobile" :style="cssVars(assetProps.bra.backgroundUrl)" id="bra-sheet" class="mobile rounded-lg d-inline-flex mr-2" elevation="2">
                            <v-input id="bra" ref="bra"
                                     :value="assets.bra ? assets.bra.url : undefined"
                                     :class="$refs.bra && $refs.bra.error ? 'mt-2' : ''"
                                     :rules="rules.asset && rules.asset.bra ? rules.asset.bra : []">
                                <file-pond class="image" ref="filepond_bra" name="filepond_bra" :label-idle="formatLabel('bra')"
                                           accepted-file-types="image/*"
                                           v-on:init="handleFilePondInit"
                                           v-bind:files="files.bra"
                                           @addfile="(error, file) => addfileHandler(file, 'bra')"
                                           @removefile="(error, file) => removefileHandler(file, 'bra')"
                                           @processfile="(error, file) => processfileHandler(file, 'bra')"
                                           @activatefile="(error, file) => activatefileHandler(file, assets[1])"
                                           stylePanelLayout="integrated"
                                           :value="assets['bra'].serverId"
                                           :server="server"
                                           :credits="null"></file-pond>
                            </v-input>
                        </v-sheet>
                        <a id="bra-tag-sheet"></a>
                        <v-sheet v-if="$vuetify.breakpoint.mobile" :style="cssVars(assetProps.tag.backgroundUrl)" id="tag-sheet" class="mobile rounded-lg d-inline-flex" elevation="2">
                            <v-input id="bra_tag" ref="tag"
                                     :value="assets.tag ? assets.tag.url : undefined"
                                     :class="$refs.tag && $refs.tag.error ? 'mt-2' : ''"
                                     :rules="rules.asset && rules.asset.tag ? rules.asset.tag : []">
                                <file-pond class="image" ref="filepond_tag" name="filepond_tag" :label-idle="formatLabel('bra tag')"
                                           accepted-file-types="image/*"
                                           v-on:init="handleFilePondInit"
                                           v-bind:files="files.tag"
                                           @addfile="(error, file) => addfileHandler(file, 'tag')"
                                           @removefile="(error, file) => removefileHandler(file, 'tag')"
                                           @processfile="(error, file) => processfileHandler(file, 'tag')"
                                           @activatefile="(error, file) => activatefileHandler(file, assets[0])"
                                           stylePanelLayout="integrated"
                                           :value="assets['tag'].serverId"
                                           :server="server"
                                           :credits="null"></file-pond>
                            </v-input>
                        </v-sheet>
                        <p class="font-italic text-body-2 mx-md-6">
                            <v-textarea id="description" class="font-weight-light mt-2"
                                        outlined
                                        counter
                                        validate-on-blur
                                        name="description"
                                        :placeholder="placeholder"
                                        label="All about this bra..."
                                        :rules="this.rules.description"
                                        v-model="$storeDescription"></v-textarea>
                        </p>
                        <v-slide-group
                                       v-model="slideGroup"
                                       class="px-2"
                                       center-active
                                       :prev-icon="mdiChevronLeft"
                                       :next-icon="mdiChevronRight">
                            <v-slide-item class="mb-6"
                                          v-for="(value, name) in slideItemAssetProps"
                                          :key="name"
                                          v-slot="{ active }"
                                          :id="getTourSelector('id', name)"
                                          :class="getTourSelector(name)">
                                <v-card
                                        :color="active ? 'primary' : 'grey lighten-1'"
                                        class="ma-2 rounded-lg"
                                        height="175"
                                        width="100">
                                    <v-row
                                           class="slide-group-row my-0"
                                           align="center"
                                           justify="center">
                                        <div :style="cssVars(value.backgroundUrl)" class="asset d-flex flex-column justify-center">
                                            <v-input :value="assets[name].serverId" :ref="name" :id="name" :rules="rules.asset ? rules.asset[name] : undefined">
                                                <file-pond :class="value.type" :ref="`filepond_${name}`" :name="`filepond_${name}`" :label-idle="formatLabel(name)"
                                                           :accepted-file-types="value.type.match(/video\/.*/) ? 'video/*' : 'image/*'"
                                                           :allowMultiple="value.type.match(/video\/.*/) ? false : false"
                                                           v-on:init="handleFilePondInit"
                                                           v-bind:files="files[name]"
                                                           @addfile="(error, file) => addfileHandler(file, name)"
                                                           @removefile="(error, file) => removefileHandler(file, name)"
                                                           @processfile="(error, file) => processfileHandler(file, name)"
                                                           @activatefile="(error, file) => activatefileHandler(file, assets[name])"
                                                           stylePanelLayout="integrated"
                                                           :imagePreviewHeight="175"
                                                           :imageResizeTargetWidth="100"
                                                           :server="server"
                                                           :credits="null">
                                                </file-pond>
                                            </v-input>
                                        </div>
                                    </v-row>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>
                        <div id="lightgallery">
                        </div>
                        <v-card-actions class="justify-center">
                            <v-row class="my-2">
                                <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 7" id="tour-step-price" class="d-flex ml-auto justify-end align-center">
                                    <v-select ref="currency" id="currency" class="text-uppercase currency-select" v-model="select" :items="currencies" item-text="name" item-value="value" hide-details="false" :append-icon="mdiChevronDown" dense filled flat
                                              @change="convertCurrency()">
                                        <template v-if="select === 'NEAR'" v-slot:prepend-inner>
                                            <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                                <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                            </icon-base>
                                        </template>
                                        <template v-else v-slot:prepend-inner>
                                            <v-icon>{{ mdiCurrencyUsd }}</v-icon>
                                        </template>
                                    </v-select>
                                    <v-text-field validate-on-blur :rules="rules.price" id="price" hide-details="auto" outlined class="mx-2" style="max-width: 175px" :label="`Price in ${select}`" hint="" dense v-model="$storePrice[select]"
                                                  @input="convertCurrency()">
                                        <template v-if="select === 'NEAR'" v-slot:append>
                                            <v-icon x-small>{{ mdiCurrencyUsd }}</v-icon>
                                            <span style="font-size: smaller">{{ $storePrice.USD }}</span>
                                        </template>
                                        <template v-else-if="select === 'USD'" v-slot:append>
                                            <icon-base height="15" width="15" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                                                <icon-near iconColor="rgba(0, 0, 0, 1)" />
                                            </icon-base>
                                            <span style="font-size: smaller">{{ $storePrice.NEAR }}</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col id="tour-step-create" class="d-flex pr-0 mr-0" :class="$vuetify.breakpoint.mobile ? 'justify-end' : ''">
                                    <v-btn :small="$vuetify.breakpoint.mobile" @click="submit" :class="valid ? 'valid text-h5 font-weight-light' : ''" :elevation="valid ? 24 : 0" :x-large="valid" outlined text>Create</v-btn>
                                </v-col>
                                <v-col class="d-flex align-center pl-0 ml-0">
                                    <v-btn @click="reset" :x-large="valid" x-small text>Reset</v-btn>
                                </v-col>
                                <v-spacer v-if="!$vuetify.breakpoint.mobile"></v-spacer>
                            </v-row>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <v-overlay :v-click-outside="NODE_ENV === 'production' ? undefined : onClickOutside" id="premint-overlay" :dark="false" :value="overlays.premint" :class="overlays.premint ? 'blur' : ''" absolute dismissable>
            <h1 class="font-italic font-weight-light">Creating Your BraNFT™...</h1>
            <v-progress-linear indeterminate></v-progress-linear>
        </v-overlay>
        <v-overlay id="mint-overlay" :dark="false" :value="overlays.mint" absolute class="d-flex justify-end">
            <ts-nft ref="minted" @close="onClickOutsideMintOverlay" margin="mx-0" :eager="true" :premint_id="premint_id"></ts-nft>
        </v-overlay>
        <v-snackbar color="#F44336" bottom :timeout="-1" :value="error">
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                       text
                       v-bind="attrs"
                       @click="error = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>
<style>
.blur {
    backdrop-filter: blur(5px);
    transition-property: backdrop-filter;
    -webkit-transition-property: backdrop-filter;
    transition-duration: 3s;
    -webkit-transition-duration: 3s;
    transition-timing-function: ease-out;
    -webkit-transition-timing-function: ease-out;
}
button.valid {
    color: green !important;
}
.cube {
    transform-style: preserve-3d;
}
.face {
    position: absolute;
    backface-visibility: hidden !important;
}
.front {
    animation: flipInX 1s linear;
}
.back {
    transform: rotateY(180deg);
}
.v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
    content: unset;
}
.currency-select {
    max-width: 150px;
}
.v-tooltip__content {
    padding: 0;
}
.pointer {
    cursor: pointer;
}
.asset .v-messages {
    position: absolute;
    text-align: center;
    margin-top: 12px;
}
.v-slide-group__content {
    justify-content: center;
}
.filepond--root {
    cursor: pointer;
    min-width: 100px;
    min-height: 175px;
}
#tag-sheet .filepond--root,
#bra-sheet .filepond--root {
    min-width: 150px;
    min-height: 150px;
}
.filepond--drop-label > label {
    cursor: pointer;
    min-width: 100px;
}
#tag-sheet .filepond--drop-label,
#bra-sheet .filepond--drop-label {
    height: 150px !important;
}
.filepond--item {
    height: 175px !important;
}
#tag-sheet .filepond--item,
#bra-sheet .filepond--item {
    height: 150px !important;
}
.disabled .thumbs .filepond--root {
    width: 100px;
}
.filepond--image-preview-wrapper {
    border-radius: 8px !important;
}
.filepond--label-action {
    text-decoration: none;
}
.filepond--file {
    padding-left: -10px;
}
.filepond--file-status {
    font-size: smaller !important;
    margin: 0 auto 0 0;
    position: absolute;
    bottom: 20px;
}
.filepond--file-info-main {
    display: none;
}
[data-filepond-item-state*="error"] .filepond--item-panel,
[data-filepond-item-state*="invalid"] .filepond--item-panel {
    font: red;
}
.filepond--file-status-sub {
    display: none;
}
[data-filepond-item-state="processing-complete"]
    .filepond--image-preview-overlay
    svg {
    color: black;
}
/**.v-input.error--text {
    margin-top: 16px;
}*/
#tag-sheet .v-input.error--text,
#bra-sheet .v-input.error--text {
    margin-top: 0px !important;
}
.error--text .filepond--drip,
.error--text #tag-sheet .filepond--drop-label,
.error--text #bra-sheet .filepond--drop-label {
    border-color: red !important;
    border-width: 2px;
    border-style: solid;
    border-radius: 8px;
    opacity: 1;
}
.error--text #tag-sheet .filepond--drip,
.error--text #bra-sheet .filepond--drip {
    border-style: none;
}
.v-input__slot {
    margin-bottom: 0;
}
#tag-sheet .v-input__slot,
#bra-sheet .v-input__slot {
    height: 150px;
}
::-webkit-scrollbar {
    display: none;
}
.filepond--file-poster-overlay:nth-of-type(2) {
    display: none;
}
.filepond--root[data-style-panel-layout~="integrated"]
    .filepond--file-poster-wrapper {
    border-radius: 8px;
}
.mobile .v-label {
    overflow: unset;
}
#ts-nft-create-form .v-card {
    border: unset;
}
#ts-nft-create-form .v-text-field .v-label {
    overflow: unset;
}
#tour-step-brand-name-size
    > div.col.col-2
    > span
    > div
    > div
    > div.v-text-field__details,
#tour-step-brand-name-size
    > div:nth-child(2)
    > span
    > div
    > div
    > div.v-text-field__details
    > div
    > div
    > div,
#tour-step-brand-name-size
    > div:nth-child(1)
    > span
    > div
    > div
    > div.v-text-field__details
    > div
    > div
    > div {
    margin-top: 0.3rem;
    white-space: nowrap;
    overflow: visible;
}
</style>
<style scoped>
.thumbnail:hover {
    transition-property: all;
    -webkit-transition-property: all;
    transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    transform: scale(1.5);
    z-index: 999;
}
.thumbs {
    border-radius: 8px;
}
.slide-group-row {
    height: 100%;
}
.asset,
#tag-sheet,
#bra-sheet {
    height: 100%;
    width: 100px;
    background-size: cover;
    background-position: center;
    position: absolute;
    background-image: var(--thumb-url);
    border-radius: 8px;
}
#bra-sheet,
#tag-sheet {
    height: 150px;
    width: 150px;
}
#tag-sheet {
    position: inherit;
}
.asset::before,
#tag-sheet::before,
#bra-sheet::before {
    content: "";
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.9);
}
.mobile #bra-sheet,
.mobile #tag-sheet {
    position: relative;
}
.asset-black {
    background-size: cover;
}
.asset-black::before {
    background-color: rgba(0, 0, 0, 1);
}
.file-added {
    height: 175px;
}
#tag-sheet .file-added,
#bra-sheet .file-added {
    height: unset;
}
</style>
<script>
import TsNft from "./TsNft.vue";
import {
    mdiVideoAccount,
    mdiChevronLeft,
    mdiChevronRight,
    mdiCurrencyUsd,
    mdiChevronDown,
    mdiYoutube,
} from "@mdi/js";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";
import lightGallery from "lightgallery/lightgallery.umd";
//import lightGallery from "lightgallery/lightgallery.min.js";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
//import lgVideo from "lightgallery/plugins/video/lg-video.es5";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import IconNear from "../components/IconNear.vue";
import IconBase from "../components/IconBase.vue";
import TsVTourTemplate from "../components/TsVTourTemplate";
import whilst from "async/whilst";
import * as Promise from "bluebird";
import "animate.css";

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFilePoster
);

export default {
    name: "TsNFTCreateForm",
    components: {
        FilePond,
        TsNft,
        IconBase,
        IconNear,
        TsVTourTemplate,
    },
    props: {
        startTour: Boolean,
        wallet: Object,
    },
    filters: {},
    data: function () {
        const { NODE_ENV, VUE_APP_API_SERVER } = process.env;
        return {
            NODE_ENV,
            VUE_APP_API_SERVER,
            error: false,
            errorMessage: null,
            files: {
                bra: null,
                tag: null,
                left: null,
                front: null,
                right: null,
                back: null,
                nude: null,
                fitting: null,
                secret: null,
            },
            debounce: false,
            showSwatches: false,
            swatches: [
                { black: "#000000" },
                { white: "#FFFFFF" },
                { grey: "#9E9E9E" },
                { nude: "#E3BC9A" },
                { red: "#F44336" },
                { pink: "#E91E63" },
                { purple: "#9C27B0" },
                { wine: "#673AB7" },
                { indigo: "#3F51B5" },
                { blue: "#2196F3" },
                { icy: "#03A9F4" },
                { cyan: "#00BCD4" },
                { teal: "#009688" },
                { green: "#4CAF50" },
                { apple: "#8BC34A" },
                { lime: "#CDDC39" },
                { yellow: "#FFEB3B" },
                { amber: "#FFC107" },
                { orange: "#FF9800" },
                { tangarine: "#FF5722" },
                { brown: "#795548" },
            ],
            token: null,
            valid: false,
            slideGroup: null,
            mdiChevronLeft,
            mdiChevronRight,
            mdiVideoAccount,
            mdiCurrencyUsd,
            mdiChevronDown,
            brasizeInputHeight: null,
            brasizeInputWidth: null,
            description: this.$storeDescription,
            placeholder: `The story behind wanting to turn my bra into a BraNFT™ is...
The history of my breast growth has been...
I love this particular bra because...`,
            rules: {
                brand: [(v) => !!v || `The bra brand is required.`],
                name: [(v) => !!v || `The bra name is required.`],
                color: [(v) => !!v || `The bra color is required.`],
                size: [
                    (v) => !!v || `The bra size is required.`,
                    () =>
                        (!!this.braBand && !!this.braCup) ||
                        "Band and cup size please.",
                ],
                description: [
                    (v) => !!v || `Please tell buyers all about your bra.`,
                    (v) =>
                        (v && v.length > 100) ||
                        "Description is far too short.",
                ],
                asset: this.assetRules,
                price: [
                    (v) => !!v || `Price your BraNFT™.`,
                    (v) => !isNaN(Number.parseFloat(v)) || "Must be a number.",
                ],
            },
            assetRules: null,
            lightGallery: null,
            premint_id: null,
            show: false,
            account: null,
            select: "NEAR",
            currencies: [
                { name: "near", value: "NEAR" },
                { name: "usd", value: "USD" },
            ],
            price: {
                NEAR: null,
                USD: null,
            },
            listing: null,
            steps: ["waiting", "premint", "mint", "complete"],
            step: null,
            tour: {
                steps: [
                    {
                        title: `BraNFT™ Studio`,
                        content: `This panel is where you create your BraNFTs using a simple web form.`,
                        target: "#nft-create-component",
                        params: {
                            placement: "top", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements,
                            highlight: true,
                        },
                        subSteps: [
                            {
                                title: `Example`,
                                content: `Click this button to see an example of a completed form.
                                    <p>Go ahead, click it!</p>`,
                                target: "#example-button",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Bra Brand, Name, and Size`,
                                content: `These fields are straight forward. Accuracy is key. Remember the information will be verifiable in your bra tag photo.`,
                                target: "#tour-step-brand-name-size",
                                params: {
                                    highlight: true,
                                    placement: "bottom",
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Color `,
                                graphic: "🌈",
                                content: `<p>For the most accurate info, your input is needed for your bra's color. Soon we may have an
                                automated way to accurately detect the color from your uploaded photos, but for now it's a manual process.</p>
                                <p>The options cover a wide range, but if you're bra color isn't listed, just pick the closest match.</p>`,
                                target: "#tour-step-color",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "left",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Bra/Tag 📸`,
                                graphic: "🏷️",
                                content: `<p>This is to upload a photo of your bra and bra tag.</p>
                                <p>You can double-click on the image area to toggle the input from tag to bra and vice versa.</p>
                                <p>A good photo will be close up (your camera's macro setting is your friend here) and clearly show the bra size and size of the bra on the tag.
                                <b>Hands</b> in the photo are great, even more <b>personalization</b>.</p>
                                `,
                                target: "#bra-tag-sheet",
                                params: {
                                    placement: "bottom",
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `About 📓`,
                                graphic: "✒️",
                                content: `This is where you really make your BraNFT™ stand out and let potential buyers understand why this bra is
                                so special and unique. The sky is the limit really and the more information and detail the better.`,
                                target: "#description",
                                params: {
                                    placement: "bottom",
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Left, Front, Right, Back 📸`,
                                content: `These upload fields should be used share corresponding photos of you wearing your bra. A view from your left profile,
                                a front view, one from your right profile, and finally a photo of your back. Remember while the model (you) is certainly important,
                                the star of the show is your bra.</p>
                                <p>Higher resolution photos are best. There probably isn't a distance from the camera  that's too close,
                                but there is certainly too far. You should fill most of the camera's frame.`,
                                target: this.$vuetify.breakpoint.mobile
                                    ? "#tour-step-right"
                                    : ".tour-step-left-front-right-back",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Nude 📸`,
                                content: `The final photo should be a nude shot from the back. This is where the focus is on you the bra owner. The bra may or may not
                                be in this photo.`,
                                target: ".tour-step-nude",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Fitting 📹`,
                                content: `This video upload field can be used for whatever you'd like. You wearing the bra and fitting it would be ideal. This video,
                                unlike the next secret video will be visible to anyone, not only the purchaser of the BraNFT™. As such, you should view it as a
                                perfect opportunity to further "sell" your collectable.`,
                                target: ".tour-step-fitting",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Secret 📹`,
                                graphic: "🔒",
                                content: `This is to upload a video made available only to the purchaser of your BraNFT™.
                                <p>The video is encrypted and stored and while anyone can access the encrypted file, <b>ONLY</b>
                                the NFT owner will be able to unlock it's content.</p>
                                Feel free to add whatever you want to the video and be sure to include in your description what
                                great content the lucky owner of your BraNFT™ has in store. 
                                `,
                                target: ".tour-step-secret",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Price`,
                                graphic: `
                                    <span style="transform: rotate(-10deg)" class="mr-n4">💲</span>
                                    <span class="mr-n4">💲</span>
                                    <span style="transform: rotate(10deg)" class="">💲</span>`,
                                content: `Here you can enter the asking price for you BraNFT™ in fiat (USD) or crypto and the price will automatically be converted for you.`,
                                target: "#tour-step-price",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Create Your BraNFT™`,
                                graphic: "✔️",
                                content: `When the fields are complete and you're ready, click this button to start the minting process!`,
                                target: "#tour-step-create",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "bottom"
                                        : "top",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                            {
                                title: `Progress`,
                                content: `<p>Here to the right you can view the progress of your BraNFT™ creation.</p>
                                    The process includes:<br>
                                    <ol>
                                        <li>Submitting the form.</li>
                                        <li>Creating a pre-mint BraNFT™.</li>
                                        <li>And finally minting your BraNFT™.</li>
                                    </ol>
                                `,
                                target: "#tour-step-progress",
                                params: {
                                    placement: this.$vuetify.breakpoint.mobile
                                        ? "top"
                                        : "left",
                                    highlight: true,
                                },
                                offset: this.$vuetify.breakpoint.mobile
                                    ? -400
                                    : 0,
                            },
                        ],
                    },
                ],
                callbacks: {
                    onStart: this.tourOnStartCallback,
                    onNextStep: this.tourOnNextStepCallback,
                    onPreviousStep: this.tourOnPreviousStepCallback,
                    onStop: this.tourOnStopCallback,
                },
                subStepCallbacks: {
                    onNextStep: this.tourSubStepOnNextStepCallback,
                    onPreviousStep: this.tourSubStepOnPreviousStepCallback,
                },
            },
            activeFaces: ["bra", "tag"],
            hovering: false,
            hoveringTimeout: null,
            aliases: null,
            overlays: {
                premint: false,
                mint: false,
                unverified: false,
            },
            unverifiedUserErrorEmitted: false,
        };
    },
    watch: {
        assetRules(value) {
            this.$set(this.rules, "asset", value);
        },
        startTour(value) {
            if (value) this.tourButtonHandler();
        },
        step(value) {
            this.$emit("step", value);
        },
    },
    computed: {
        imageExtension() {
            console.log({navigator})
            const ext = /^((?!chrome|android).)*safari/i.test(window?.navigator?.userAgent) ? 'jpeg' : 'webp'
            console.log({ext})
            return ext
        },
        assetProps() {
            return {
                tag: {
                    type: "image/*",
                    description: "bra tag",
                    backgroundUrl: `/nft-asset-tag.${this.imageExtension}`,
                    rulesMessages: [`Bra tag photo missing.`],
                },
                bra: {
                    type: "image/*",
                    description: "bra",
                    backgroundUrl: `/nft-asset-bra.${this.imageExtension}`,
                    rulesMessages: [`Bra photo missing.`],
                },
                left: {
                    type: "image/*",
                    description: "left view",
                    backgroundUrl: `/nft-asset-left.${this.imageExtension}`,
                    rulesMessages: [`Left side photo missing.`],
                },
                front: {
                    type: "image/*",
                    description: "front view",
                    backgroundUrl: `/nft-asset-front.${this.imageExtension}`,
                    rulesMessages: [`Front view photo missing.`],
                },
                right: {
                    type: "image/*",
                    description: "right view",
                    backgroundUrl: `/nft-asset-right.${this.imageExtension}`,
                    rulesMessages: [`Right side photo missing.`],
                },
                back: {
                    type: "image/*",
                    description: "back view",
                    backgroundUrl: `/nft-asset-back.${this.imageExtension}`,
                    rulesMessages: [`Back view photo missing.`],
                },
                nude: {
                    type: "image/*",
                    description: "back view nude",
                    backgroundUrl: `/nft-asset-back-nude.${this.imageExtension}`,
                    rulesMessages: [`Back sans bra photo missing.`],
                },
                fitting: {
                    type: "video/*",
                    description: "fitting",
                    backgroundUrl: this.iconToUrl(mdiYoutube),
                    rulesMessages: [`Fitting video missing.`],
                },
                secret: {
                    type: "video/*",
                    description: "secret",
                    backgroundUrl: this.iconToUrl(mdiYoutube),
                    rulesMessages: [`Secret video missing.`],
                },
            }
        },
        callbackErrorCode() {
            return this.$store.state.errorCode;
        },
        callbackErrorMessage() {
            return this.$store.state.errorCode;
        },
        assets() {
            return this.$store.state.form.assets;
        },
        braColors() {
            return [this.swatches.map((c) => Object.values(c)[0])];
        },
        swatch() {
            const swatch = this.swatches.find((s) => {
                const re = new RegExp(`${Object.values(s)[0]}`, "i");
                return this.$storeBraColor.match(re);
            });
            return JSON.stringify({
                name: Object.keys(swatch)[0],
                color: Object.values(swatch)[0],
            });
        },
        braBand() {
            let band;
            const match = this.$storeBraSize
                ? this.$storeBraSize
                      .toLowerCase()
                      .match(/(2[89]|[3-9]\d|10[0-2])([d-z]{1,3})/)
                : null;
            if (match && match.length > 0) band = match[1];
            return band;
        },
        braCup() {
            let cup;
            const match = this.$storeBraSize
                ? this.$storeBraSize
                      .toLowerCase()
                      .match(/(2[89]|[3-9]\d|10[0-2])([d-z]{1,3})/)
                : null;
            if (match && match.length > 1) cup = match[2];
            return cup;
        },
        server() {
            return {
                url: `${this.VUE_APP_API_SERVER}/v1/account/nft/process`,
                withCredentials: true,
                instantUpload: true,
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
                process: {
                    onload: this.filepondOnload,
                    onerror: this.filepondProcessOnerror,
                },
                load: {
                    onerror: this.filepondLoadOnerror,
                },
            };
        },
        username() {
            const username = this.$auth.user.nickname;
            const usernameArray = username.match(/(.*)\s\((.*)\)\s(.*)/);
            if (!usernameArray) {
                this.$emit("unverified");
                return {
                    full: "BraNFT™ (Not Verified) User",
                    first: "BraNFT™",
                    firstPlural: `BraNFT's`,
                    last: "User",
                    nickname: "Not Verified",
                };
            }
            const first = usernameArray[1],
                firstPlural = usernameArray[1].endsWith("s")
                    ? `${usernameArray[1]}'`
                    : `${usernameArray[1]}'s`,
                last = usernameArray[3],
                nickname = usernameArray[2];
            return { full: username, first, firstPlural, last, nickname };
        },
        lgDynamicEl() {
            return Object.keys(this.assets)
                .filter((asset) => this.assets[asset] && this.assets[asset].url)
                .map((key) => {
                    const asset = this.assets[key];
                    const assetProp = this.assetProps[key];
                    let lightGalleryObject = {
                        url: asset.url,
                        subHtml: `<h4>${key}</h4><p>${assetProp.description}</p>`,
                    };
                    if (assetProp.type.match(/image\/.*/)) {
                        lightGalleryObject = {
                            src: asset.url,
                            thumb: asset.thumb,
                            ...lightGalleryObject,
                        };
                    } else if (assetProp.type.match(/video\/.*/)) {
                        lightGalleryObject = {
                            video: {
                                source: [
                                    { src: asset.url, type: assetProp.type },
                                ],
                                src: asset.url,
                                type: assetProp.type,
                            },
                            poster: "https://picsum.photos/id/497/1080/1080",
                            thumb: asset.url,
                            ...lightGalleryObject,
                        };
                    }
                    return lightGalleryObject;
                });
        },
        autoMint() {
            return true;
        },
        tourState() {
            return this.$store.state.tour;
        },
        slideItemAssetProps() {
            const slideItemAssetProps = { ...this.assetProps };
            delete slideItemAssetProps.bra;
            delete slideItemAssetProps.tag;
            return slideItemAssetProps;
        },
        $storeBraBrand: {
            get: function () {
                return this.$store.state.form.createNft.bra.brand;
            },
            set: function (value) {
                this.$store.commit("updateBraBrand", value);
            },
        },
        $storeBraName: {
            get: function () {
                return this.$store.state.form.createNft.bra.name;
            },
            set: function (value) {
                this.$store.commit("updateBraName", value);
            },
        },
        $storeBraColor: {
            get: function () {
                return this.$store.state.form.createNft.bra.color;
            },
            set: function (value) {
                this.$store.commit("updateBraColor", value);
            },
        },
        $storeBraSize: {
            get: function () {
                return this.$store.state.form.createNft.bra.size;
            },
            set: function (value) {
                this.$store.commit("updateBraSize", value);
            },
        },
        $storeDescription: {
            get: function () {
                return this.$store.state.form.createNft.description;
            },
            set: function (value) {
                this.$store.commit("updateDescription", value);
            },
        },
        $storePrice: {
            get: function () {
                return this.$store.state.form.createNft.price;
            },
            set: function (value) {
                this.$store.commit("updatePrice", value);
            },
        },
        currentJob() {
            return this.$store.state.currentJob;
        },
    },
    beforeUnmount() {
        if (this.$store.state.resetFormOnReload) {
            this.$reset();
            this.$store.commit("resetFormOnReload", false);
        }
    },
    mounted() {
        const self = this;
        if (self.$route.query.errorCode) return self.handleCallbackErrors();
        if (self.$route.query.success)
            if (process.env.NODE_ENV !== "production")
                console.log(self.roles());
        if (self.startTour) tourButtonHandler();
        global.$store = this.$store;
        //if (NODE_ENV !== "production") self.development();
        self.rendered();
        (async function () {
            self.token = await self.$auth.getTokenSilently();
            if (self.callbackErrorCode) {
                self.closeAllOverlays();
                self.step = 1;
                self.$store.commit("clearError");
            } else if (
                self.$store.state.hooks["callMintContract"] &&
                !self.$store.state.hooks.callMintContract.done &&
                self.$store.state.creationState.func === "mint"
            ) {
                await self.mint(self.$store.state.creationState.params, true);
            } else if (
                self.$store.state.hooks["callMintContract"] &&
                !self.$store.state.hooks.callMintContract.done
            ) {
                self.$set(self.overlays, "premint", true);
                setTimeout(async () => {
                    self.$backend.io.emit("callMintContract_complete");
                    self.$store.commit("setHook", {
                        callMintContract: { done: Date.now() },
                    });

                    const nft = await self.$backend.createNftMintStatus(
                        self.currentJob.id
                    );
                    self.premint_id = nft.premint_id;
                    if (nft.token_id) {
                        self.step =
                            self.steps.findIndex(
                                (step) => step === "complete"
                            ) + 1;
                        self.$emit("created", nft);
                        self.$set(self.overlays, "premint", false);
                        self.$store.commit("resetFormOnReload", true);
                        self.turnOnOverlay("mint");
                        self.$store.commit({ type: "set", currentJob: {} });
                    }
                }, 0);
            } else if (self.currentJob.id) {
                /** job is currently in some processing state */
                self.$set(self.overlays, "premint", true);
                const job = await self.$backend.getJobStatus(
                    self.currentJob.id,
                    "mint"
                );
                if (job && !job.finishedOn && !(job instanceof Error)) {
                    setTimeout(async () => {
                        self.step = 2;
                        const nft = await self.$backend.createNftMintStatus(
                            self.currentJob.id
                        );
                        self.premint_id = nft.premint_id;
                        if (nft.token_id) {
                            self.step =
                                self.steps.findIndex(
                                    (step) => step === "complete"
                                ) + 1;
                            self.$emit("created", nft);
                            self.$set(self.overlays, "premint", false);
                            self.turnOnOverlay("mint");
                            self.$store.commit("resetFormOnReload");
                            self.$store.commit({
                                type: "set",
                                currentJob: {},
                            });
                        }
                    }, 0);
                } else {
                    self.$store.commit("setHook", {
                        callMintContract: { set: null },
                    });
                    self.$store.commit({ type: "set", currentJob: {} });
                    self.closeAllOverlays();
                    self.step = 1;
                }
            }
            const htmlFormattedAliases = await self.$backend.getCreatorAliases(
                self.username.full
            );
            if (htmlFormattedAliases)
                self.$set(self, "aliases", htmlFormattedAliases.join(", "));
            self.listing = await self.$backend.getLatestNearListing();
            Object.keys(self.assets).map((asset) => {
                if (!self.assets[asset] || !self.assets[asset].serverId) return;
                self.files[asset] = [
                    {
                        source: self.assets[asset].serverId,
                        options: {
                            type: "local",
                        },
                    },
                ];
            });
        })(self);
        let assetRules = {};
        Object.keys(self.assets).map((label) => {
            switch (label) {
                case "bra":
                case "tag":
                case "left":
                case "front":
                case "right":
                case "back":
                case "nude":
                case "fitting":
                case "secret":
                    assetRules[label] = [
                        (v) => {
                            return (
                                !!v || this.assetProps[label].rulesMessages[0]
                            );
                        },
                    ];
                    break;
                default:
                    assetRules[label] = [
                        (v) => {
                            return !!v || `Oops!`;
                        },
                    ];
            }
            self.$set(self, "assetRules", assetRules);
        });
        this.lightGallery = lightGallery(
            document.getElementById("lightgallery"),
            {
                plugins: [lgZoom, lgThumbnail, lgVideo],
                dynamic: true,
                dynamicEl: this.lgDynamicEl,
                currentPagerPosition: "middle",
                thumbnail: true,
                autoplayVideoOnSlide: true,
            }
        );
        global.closeAllOverlays = this.closeAllOverlays;
    },
    methods: {
        openExampleInNewTab: function () {
            window.open(`https://${document.domain}/branft/example`, "_blank");
        },
        handleCallbackErrors: function () {
            const { errorCode, errorMessage } = this.$route.query;
            this.$store.commit({ type: "set", errorCode });
            this.$store.commit({ type: "set", errorMessage });
            this.$router
                .replace({ "query.errorCode": undefined })
                .catch(() => {});
            this.$router
                .replace({ "query.errorMessage": undefined })
                .catch(() => {});
            this.$root.$emit(
                "nearUserRejected",
                decodeURIComponent(errorMessage)
            );
        },
        activeFaceClass: function (face) {
            return this.activeFaces[0] === face ? "front" : "back";
        },
        changeActiveFaceClass: function (face) {
            if (this.activeFaceClass(face) !== face)
                this.activeFaces.unshift(this.activeFaces.pop());
        },
        onClickOutside: function () {
            if (this.debounce) return;
            this.closeAllOverlays();
        },
        closeAllOverlays() {
            const self = this;
            Object.keys(self.overlays).map((overlay) => {
                self.$set(self.overlays, overlay, false);
            });
        },
        onClickOutsideMintOverlay: function () {
            this.reset();
            this.onClickOutside();
        },
        development() {
            this.premint_id = "pySl1hZzhgSjiu1qpwpnPS";
            setTimeout(() => {
                //this.mint();
            }, 3000);
        },
        swatchClickHandler() {
            const self = this;
            if (self.debounce) return;
            self.debounce = true;
            setTimeout(() => {
                self.debounce = false;
            }, 1000);
            this.showSwatches = true;
        },
        swatchInputHandler() {
            const self = this;
            self.debounce = true;
            setTimeout(() => {
                self.debounce = false;
            }, 1000);
            this.showSwatches = false;
        },
        cssVars(backgroundUrl) {
            let css = {
                "--thumb-url": `url("${backgroundUrl}")`,
            };
            return css;
        },
        formatLabel(param) {
            return typeof param === "string"
                ? `<span class="text-h4 text-capitalize" style="font-family: 'Allura', cursive !important;">${param}</span>`
                : `
                <!--<span aria-hidden="true" class="v-icon notranslate theme--light">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg">
                        <path d="${mdiVideoAccount}"></path>
                    </svg>
                </span>-->
                <span class="text-h4 text-capitalize filepond--label-action" style="font-family: 'Allura', cursive !important;">${param.label}</span>
            `;
        },
        handleFilePondInit() {},
        addfileHandler(file, assetLabel) {
            const component =
                this.$refs[assetLabel] instanceof Array
                    ? this.$refs[assetLabel][0]
                    : this.$refs[assetLabel];
            component.errorBucket = [];
            const id = file.id;
            const el = document.querySelector(`[id$="${id}"]`);
            const wrapper =
                el.parentElement.parentElement.parentElement.parentElement;
            const asset =
                el.parentElement.parentElement.parentElement.parentElement
                    .parentElement.parentElement.parentElement.parentElement;
            const thumbUrl = asset.style.getPropertyValue("--thumb-url");
            asset.classList.add("asset-black");
            asset.style.setProperty(
                "--thumb-url",
                thumbUrl.replace(/.webp/, `-black.${this.imageExtension}`)
            );
            wrapper.classList.add("file-added");
            if (assetLabel === "fitting") {
                const filepondFile = wrapper.__vue__.getFile();
                if (!filepondFile) return;
                filepondFile.setMetadata(
                    "poster",
                    this.iconToUrl(mdiYoutube, {
                        width: 24,
                        height: 24,
                        fill: "red",
                    })
                );
            } else if (assetLabel === "secret") {
                const filepondFile = wrapper.__vue__.getFile();
                if (!filepondFile) return;
                filepondFile.setMetadata(
                    "poster",
                    `/everyday-basics-GJY1eAw6tn8-unsplash.${this.imageExtension}`
                );
            }
        },
        removefileHandler(file, label) {
            const id = file.id;
            const el = document.querySelector(`[id$="${id}"]`);
            const wrapper =
                el.parentElement.parentElement.parentElement.parentElement;
            const assetElement =
                el.parentElement.parentElement.parentElement.parentElement
                    .parentElement.parentElement.parentElement.parentElement;
            const thumbUrl = assetElement.style.getPropertyValue("--thumb-url");
            if (!assetElement.classList.contains("asset-black")) {
                Promise.delay(1000).then(() => {
                    assetElement.classList.remove("asset-black");
                    assetElement.style.setProperty(
                        "--thumb-url",
                        thumbUrl.replace(/-black.webp/, `.${this.imageExtension}`)
                    );
                    wrapper.classList.remove("file-added");
                });
            } else {
                assetElement.classList.remove("asset-black");
                assetElement.style.setProperty(
                    "--thumb-url",
                    thumbUrl.replace(/-black.webp/, `.${this.imageExtension}`)
                );
                wrapper.classList.remove("file-added");
            }
            this.$store.commit("resetAsset", label);
            const input = this.$refs.form.$data.inputs.find(
                (input) => input.id === label
            );
            if (input) input.reset();
        },
        processfileHandler(filepond, label) {
            const asset = this.assets[label];
            if (filepond.fileType.match(/image\/.*/)) {
                const canvas = document
                    .querySelector(`[id$="${filepond.id}"]`)
                    .querySelector("canvas");
                if (!canvas) return;

                const thumbnail = document.createElement("canvas");
                thumbnail.width = 100;
                thumbnail.height = 100;
                const ctx = thumbnail.getContext("2d");
                ctx.drawImage(
                    canvas,
                    0,
                    0,
                    150,
                    (300 * canvas.height) / canvas.width
                );
                asset.thumb = thumbnail.toDataURL(`image/${this.imageExtension}`);
            }
            asset.type = filepond.fileType;
            asset.url = URL.createObjectURL(filepond.file);
            if (label.match(/bra|tag/))
                this.$refs[label === "bra" ? "tag" : "bra"].validate();
            if (
                label.match(/bra|tag/) &&
                !this.$refs[label === "bra" ? "tag" : "bra"].valid
            ) {
                this.activeFaces.unshift(this.activeFaces.pop());
                this.onClickOutsideBra();
            }
            if (label === "fitting") {
                filepond.setMetadata(
                    "poster",
                    this.iconToUrl(mdiYoutube, {
                        width: 24,
                        height: 24,
                        fill: "red",
                    })
                );
            } else if (label === "secret") {
                filepond.setMetadata(
                    "poster",
                    `/everyday-basics-GJY1eAw6tn8-unsplash.${this.imageExtension}`
                );
            }
            const assets = { ...this.assets };
            assets[label] = asset;
            this.$store.commit("updateAssets", assets);
        },
        activatefileHandler(file, asset) {
            if (!file || !asset) return;
            this.lightGallery.refresh(this.lgDynamicEl);
            const index = this.lgDynamicEl.findIndex(
                (el) => el.url === asset.url
            );
            this.lightGallery.openGallery(index > -1 ? index : 0);
        },
        turnOnOverlay(overlay, timeout = 1000) {
            const self = this;
            this.debounce = true;
            this.$set(this.overlays, overlay, true);
            setTimeout(() => {
                self.debounce = false;
            }, timeout);
        },
        async submit() {
            const self = this;
            if (self.unverifiedUserErrorEmitted) {
                self.unverifiedUserErrorEmitted = false;
                this.$auth.getTokenSilently({ ignoreCache: true }).then(() => {
                    self.submit();
                });
                return;
            }
            if (!self.roles().includes("verified")) {
                self.unverifiedUserErrorEmitted = true;
                self.$root.$emit("unverifiedUserError");
                return;
            }
            if (!this.$refs.bra.valid) return self.changeActiveFaceClass("bra");
            if (!this.$refs.tag.valid) return self.changeActiveFaceClass("tag");
            if (!this.$refs.form.validate()) return;
            this.turnOnOverlay("premint");
            this.step = this.steps.findIndex((step) => step === "premint") + 1;
            const hiddenFields = Array.from(
                this.$refs.form.$el.querySelectorAll('input[type="hidden"]')
            )
                .filter((input) => !!input.name)
                .map((input) => ({ [input.name]: input.value }))
                .reduce((acc, cur) => {
                    acc[Object.keys(cur)[0]] = Object.values(cur)[0];
                    return acc;
                }, {});
            const nonFileFields = this.$refs.form.$data.inputs
                .filter(
                    (input) =>
                        input.id &&
                        !input.id.match(
                            /bra$|bra_tag|left|front|right|back|nude|fitting|secret/
                        )
                )
                .map((input) => ({
                    [input.id]:
                        input.id === "bra_size"
                            ? {
                                  band: this.braBand,
                                  cup: this.braCup,
                              }
                            : input.id === "bra_color"
                            ? this.swatch
                            : input.id === "price"
                            ? this.$near.utils.format.parseNearAmount(
                                  `${input.value}`
                              )
                            : input.value,
                }))
                .reduce((acc, cur) => {
                    acc[Object.keys(cur)[0]] = Object.values(cur)[0];
                    return acc;
                }, {});

            try {
                const job = await this.$backend.createNft({
                    fields: { ...hiddenFields, ...nonFileFields },
                });
                this.step = this.steps.findIndex((step) => step === "mint") + 1;
                this.premint_id =
                    job.data.nftPremint.nftPremintObject.premint_id;

                self.$store.commit({
                    type: "set",
                    currentJob: { id: job.id },
                });
                const nft = await this.$backend.createNftMintStatus(job.id);
                /**
                 * In certain cases (user is new) the backend should mint the nft onchain using the users guest account
                 * in which case a token_id should be present on the returned object.
                 */
                await new Promise((resolve) => setTimeout(resolve, 3000));
                if (nft.token_id) {
                    this.step =
                        this.steps.findIndex((step) => step === "complete") + 1;
                    this.$emit("created", nft);
                    this.$set(this.overlays, "premint", false);
                    this.turnOnOverlay("mint");
                    self.$store.commit("resetFormOnReload");
                }
                /** if there's no token_id, it means we're waiting for the client to complete the web3 transaction locally */
            } catch (error) {
                this.errorMessage = error;
                this.error = true;
                self.$store.commit({ type: "set", currentJob: {} });
                self.step = 1;
                self.closeAllOverlays();
            }
        },
        lgOnInit() {},
        lgOnBeforeSlide() {},
        async mint(contractArgs, reset) {
            const self = this;
            self.step = this.steps.findIndex((step) => step === "mint") + 1;
            await self.$near.mint(contractArgs, reset);
        },
        async convertCurrency() {
            if (this.select === "NEAR" && this.listing) {
                if (isNaN(this.$storePrice.NEAR)) return;
                this.$set(
                    this.$storePrice,
                    "USD",
                    Number.parseFloat(
                        this.$storePrice.NEAR *
                            this.listing.averageUSD
                    ).toFixed(2)
                );
            } else if (this.select === "USD" && this.listing) {
                if (isNaN(this.$storePrice.USD)) return;
                this.$set(
                    this.price,
                    "NEAR",
                    Number.parseFloat(
                        this.$storePrice.USD *
                            (1 / this.listing.averageUSD)
                    ).toFixed(2)
                );
            }
        },
        tourButtonHandler() {
            this.$tours["welcome"].start(this.tourState.currentStep);
        },
        tourOnStartCallback() {
            const { currentStep } = this.tourState;
            const subStep = currentStep - 1; // if welcome.subSteps otherwise another switch is needed
            if (currentStep > 0 && currentStep <= 12) {
                this.$tours["welcome.subSteps"].start(subStep);
            }
        },
        tourOnStopCallback() {
            localStorage.setItem("welcome-tour", true);
            this.$tours["welcome.subSteps"].stop();
        },
        tourOnNextStepCallback(currentStep) {
            const futureStep = currentStep + 1;
            switch (`${currentStep}`) {
                case "0":
                    this.$tours["welcome.subSteps"].start();
                    this.$store.commit({
                        type: "set",
                        tour: { currentStep: futureStep },
                    });
                    break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                    this.slideGroup = 4;
                    break; // nude
                case "8":
                    this.slideGroup = 5;
                    break; // fitting
                case "9":
                    this.slideGroup = 6;
                    break; // secret
                case "10":
                case "11":
                    this.$tours["welcome.subSteps"].nextStep();
                    this.$store.commit({
                        type: "set",
                        tour: { currentStep: futureStep },
                    });
                    break;
            }
        },
        tourOnPreviousStepCallback(currentStep) {
            const futureStep = currentStep - 1;
            switch (`${currentStep}`) {
                case "0":
                    this.$tours["welcome.subSteps"].stop();
                    this.$store.commit({
                        type: "set",
                        tour: { currentStep: futureStep },
                    });
                    break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                    this.slideGroup = 4;
                    break;
                case "8":
                    this.slideGroup = 5;
                    break;
                case "9":
                    this.slideGroup = 6;
                    break;
                case "10":
                case "11":
                case "12":
                    this.$tours["welcome.subSteps"].previousStep();
                    this.$store.commit({
                        type: "set",
                        tour: { currentStep: futureStep },
                    });
                    break;
            }
        },
        tourSubStepOnNextStepCallback(currentStep) {
            switch (`${currentStep}`) {
                case "4":
                    this.slideGroup = 2;
                    break; // left
                case "5":
                    this.slideGroup = 4;
                    break; // nude
                case "6":
                    this.slideGroup = 5;
                    break; // fitting
                case "7":
                    this.slideGroup = 6;
                    break; // secret
            }
        },
        tourSubStepOnPreviousStepCallback(currentStep) {
            switch (`${currentStep}`) {
                case "6":
                    this.slideGroup = 2;
                    break;
                case "7":
                    this.slideGroup = 6;
                    break;
                case "8":
                    this.slideGroup = 7;
                    break;
            }
        },
        getTourSteps(name) {
            if (name.match(/.subSteps/)) {
                return this.tour.steps[0].subSteps;
            } else {
                const steps = this.tour.steps
                    .map((step) => {
                        return new Array(step.subSteps.length + 1)
                            .fill()
                            .map(() => ({ ...step }));
                    })
                    .flat();
                return steps;
            }
        },
        getTourSelector(type = "class", assetLabel) {
            if (!assetLabel) {
                assetLabel = type;
                type = "class";
            }
            let label;
            switch (assetLabel) {
                case "left":
                case "front":
                case "right":
                case "back":
                    label =
                        type === "class"
                            ? "tour-step-left-front-right-back"
                            : `tour-step-${assetLabel}`;
                    break;
                default:
                    label = `tour-step-${assetLabel}`;
            }
            return label;
        },
        rendered() {
            const self = this;
            const formRefs = ["form"].concat(Object.keys(self.assets));
            whilst(
                function (callback) {
                    callback(
                        null,
                        formRefs
                            .map(
                                (ref) =>
                                    !!self.$refs.form.$data.inputs
                                        .map((component) => component.id)
                                        .find((id) => id === ref)
                            )
                            .filter((ref) => !ref).length === 0
                    );
                    /**
                    console.log(self.$refs.form.$data.inputs.map(component => component.id))
                    const mapped = formRefs.map(ref => {
                        const isRefRendered = !!self.$refs.form.$data.inputs.map(component => component.id)
                            .find(id => id === ref);
                        return !isRefRendered;
                    })
                    console.log('length: ', mapped.filter(ref => !ref).length);
                    callback(null, mapped.filter(ref => !ref).length === 0)
                    */
                },
                function (callback) {
                    Promise.delay(500).then(callback);
                },
                onRendered
            );
            function onRendered() {
                self.$emit("mounted", self.$refs.form);
                self.brasizeInputHeight =
                    document.getElementById(
                        "bra_size"
                    ).parentElement.offsetHeight;
            }
        },
        onDoubleClick() {
            this.activeFaces.unshift(this.activeFaces.pop());
            console.log(this.activeFaces);
        },
        onClickOutsideBra() {
            this.$set(this, "hovering", false);
            clearTimeout(this.hoveringTimeout);
        },
        filepondOnload(response) {
            const fileField = response.split(":")[0];
            const serverId = response.split(":")[1];
            const inputId = fileField.split("_")[1];
            const assets = { ...this.assets };
            assets[inputId].serverId = serverId;
            this.$store.commit("updateAssets", assets);
            return serverId;
        },
        filepondProcessOnerror(errorString) {
            let error = new Error(errorString);
            if (errorString.match(/insufficient scope/i)) {
                error = new Error("Please confirm your account first.");
            }

            this.$root.$emit("createFormError", error);
            return errorString;
        },
        filepondLoadOnerror(response) {
            const self = this;
            const { type } = response;
            if (type === "text/plain") {
                response.text().then(async (file) => {
                    const input = this.$refs.form.$data.inputs.find(
                        (input) =>
                            self.assets[input.id] &&
                            self.assets[input.id].serverId === file
                    );
                    if (!input) return;
                    await input.$el
                        .querySelector(".filepond--wrapper")
                        .__vue__.removeFiles();
                });
            }
            return response;
        },
        iconToUrl(icon, options = { width: 24, height: 24, fill: "black" }) {
            const { width, height, fill } = options;
            const path = icon;
            const base64 = btoa(
                `<svg xmlns="http://www.w3.org/2000/svg" fill="${fill}" width="100" height="175" viewBox="0 0 ${height} ${width}" role="img" aria-hidden="true" class="v-icon__svg"><path d="${path}"></path></svg>`
            );
            const url = `data:image/svg+xml;base64,${base64}`;
            return url;
        },
        reset() {
            const self = this;
            self.$emit("reset");
            self.$store.commit("resetForm", 'createNft');
            self.$refs.form.reset();
            Object.keys(self.$refs)
                .filter((key) => key.match(/filepond_/))
                .map((key) => {
                    self.$refs[key] instanceof Array
                        ? self.$refs[key][0].removeFiles()
                        : self.$refs[key].removeFiles();
                });
            self.$nextTick(() => {
                self.$set(self, "select", "NEAR");
                self.$set(self.$refs.currency, "lazyValue", self.select);
                self.$set(self.$refs.bra_color, "lazyValue", self.swatch);
            });
        },
        roles() {
            return this.$auth.user
                ? this.$auth.user[`https://${tld}/roles`]
                : undefined;
        },
    },
};
</script>
